export interface SkinDate {
    dateFIAF?: string | null,
    useDate: string,
    empty: boolean,
    endInterval?: SkinInterval | null,
    startInterval?: SkinInterval | null,
    txt: string
}

export interface SkinInterval {
    date?: number | null
    dateTxt?: string | null
    dateYear?: string | null
    unit?: any // DateUnit | null
    yearAsNumber?: number | null
}

export enum SkinDateFormat {
    DATE,
    TEXT,
    NEGATIVE
}